import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { SettingsApiKeysStepUi } from "@src/widgets/onboarding/ui/tours/ApiIntegration/SettingsApiKeysStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class SettingsApiKeysStep extends TourStepBase {
  component = SettingsApiKeysStepUi
  name = `${ONBOARDING_TOURS.API_INTEGRATION}_SettingsApiKeysStep`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_SETTINGSAPIKEYS_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.settings,
      search: `?${createSearchParams({ tab: "ak" })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Connect seamlessly with our service",
      title: "API Keys Creation",
    }
  }
}
